import { render, staticRenderFns } from "./signInScreen.vue?vue&type=template&id=2071c5e9&"
import script from "./signInScreen.vue?vue&type=script&lang=ts&"
export * from "./signInScreen.vue?vue&type=script&lang=ts&"
import style0 from "./signInScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports